const Facilities = ({facility}) => {
  return (
    <>
        <div className="col-xl-12">
          <div className="row y-gap-30">
          {facility?.map((item,index) => (
            item?.tags.length!==0? <div className="col-12" key={item?._id}>
            <div>
              
              <div className="d-flex items-center text-16 fw-600">
                <i className={`${item?.name} text-20 mr-10`} />
                {item?.name}
              </div>
              <ul className="text-15 pt-10">
                {item?.tags?.map((val, i) => (
                  <li className="d-flex items-center" key={i}>
                    <i className="icon-check text-10 mr-20" style={{color:"green"}}/>
                    {val}
                  </li>
                ))}
              </ul>
            </div>
          </div>:""
             
            ))}
          </div>
        </div>
    </>
  );
};

export default Facilities;
